<div class="lvi-content">
    <div class="avatar">
        <mat-icon>filter_alt</mat-icon>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a>{{ data.libelle }}</a>
        </div>
        <ul *ngIf="data.type != TypeFiltreChar.TYPE_RUBRIQUE" class="lvi-attrs">
            <li>
                <strong [translate]="'admin.frais.prestations.detail.filtres.listeFiltres.type'"></strong>
                <span>{{ ('admin.frais.prestations.detail.filtres.listeFiltres.' + data.type) | translate }}</span>
            </li>
            <li *ngIf="data.type == TypeFiltreChar.TYPE_MOT_CLE || data.type == TypeFiltreChar.TYPE_ORGANISATION">
                <strong [translate]="'admin.frais.prestations.detail.filtres.listeFiltres.parException'"></strong>
                <span>{{ (data.modificateur == '-' ? 'global.oui' : 'global.non') | translate }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions">
        <button mat-icon-button (click)="deleteFiltre()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>